export default __webpack_public_path__ + "static/media/invoices.9b6853bb.svg";